import { Chip, Typography } from '@mui/material'

import { useTranslation } from '@/core'
import { Organism, OrganismFrame } from '@/core/architecture'

type ResaleCategoryProps = {
  isResaleAvailable: boolean
}

export const ResaleCategory: Organism<ResaleCategoryProps> = ({
  isResaleAvailable,
}) => {
  const { t } = useTranslation('resaleCreate')
  return (
    <OrganismFrame>
      <Chip
        size="small"
        sx={{
          width: 76,
          height: 20,
          borderRadius: '2px',
          bgcolor: isResaleAvailable ? 'primary.main' : 'grey.100',
          py: 1,
          '.MuiChip-label': {
            px: 0,
          },
        }}
        label={
          <Typography
            color={isResaleAvailable ? 'white' : 'text.secondary'}
            variant="overline"
          >
            {isResaleAvailable
              ? t('duringExhibitionPeriod')
              : t('outsideExhibitionPeriod')}
          </Typography>
        }
      />
    </OrganismFrame>
  )
}
